import { useEffect } from "react";
import DollhouseMapContainer from "./DollhouseMapContainer";
// import LevelchangerLoader from "./LevelchangerLoader";
// import { useState } from "react";

const DollhouseView = ({
  renderViewType,
  currentAreaSelected,
  mapRenderDatas,
  isExploreareaView,

  levelMapReset,
  dollhouseImages,
}) => {
  // const [_levelChangerLoaderState, setLevelChangerState] = useState(false);

  // const UpdateLevelChangerLoaderVisibility = (status) => {
  //   setLevelChangerState(status);
  // };

  return (
    <>
      {/* <LevelchangerLoader loaderStatus={_levelChangerLoaderState} /> */}
      {/* <NativeSelectDemo></NativeSelectDemo> */}
      <DollhouseMapContainer
        // updateLevelChangerLoaderVisibility={UpdateLevelChangerLoaderVisibility}
        renderViewType={renderViewType}
        currentAreaSelected={currentAreaSelected}
        isExploreareaView={isExploreareaView}
        mapRenderDatas={mapRenderDatas}
        levelMapReset={levelMapReset}
        dollhouseImages={dollhouseImages}
      />
    </>
  );
};

export default DollhouseView;
